import React from "react"
import {useTranslation} from "react-i18next"

import {IonButton, IonIcon, useIonAlert} from "@ionic/react"
import {alertOutline, alertSharp, trashOutline, trashSharp} from "ionicons/icons"

import {useUsers} from "../../../contexts/UserContext"

import User                    from "../../../types/User"
import LockingSystemPermission from "../../../types/LockingSystemPermission"

interface componentProps {
    item: LockingSystemPermission
    user: User
}

const ButtonDelete: React.FC<componentProps> = ({item, user} ) => {

    const { t } = useTranslation()
    const [presentAlert] = useIonAlert();

    const { deleteLockingSystemPermission } = useUsers()

    const alertDelete = (ev: any) => {
        ev.preventDefault()
        ev.stopPropagation()

        return presentAlert({
            header:  t('userLockingSystemPermissions.alerts.delete.header'),
            message: t('userLockingSystemPermissions.alerts.delete.message'),
            buttons: [{
                text: t('common.cancel'),
                role: 'cancel',
            }, {
                text: t('common.continue'),
                role: 'confirm',
                handler: () => { onDelete() },
            },]
        })
    }

    const onDelete = async () => {
        await deleteLockingSystemPermission(user, item)
    }

    return (
        <IonButton fill="clear" slot="end" onClick={(ev) => alertDelete(ev)} type="button">
            {item.options?.isRemovableFromKey ?
                <IonIcon color="medium" ios={trashOutline} md={trashSharp} slot="icon-only" /> :
                <IonIcon color="medium" ios={alertOutline} md={alertSharp} slot="icon-only" />
            }
        </IonButton>
    )
}

export default ButtonDelete